import "swiper/swiper-bundle.css";

import { Autoplay, Pagination } from "swiper/modules";

import Swiper from "swiper";
import simpleParallax from "simple-parallax-js";

var images = document.querySelectorAll(".hero img");
new simpleParallax(images, {
	scale: 1.075,
});

Array.from(document.querySelectorAll(".hero .swiper")).map((hero) => {
	const swiper = new Swiper(hero, {
		modules: [Autoplay, Pagination],
		autoplay: {
			delay: 7500,
		},
		loop: true,
		pagination: {
			el: ".swiper-pagination",
			type: "bullets",
			clickable: true,
		},
	});

	Array.from(document.querySelectorAll(".hero .pagination button")).map(
		(button) => {
			button.addEventListener("click", (e) => {
				swiper.slideTo(button.getAttribute("data-slide-index"));
			});
		}
	);

	swiper.on("slideChange", () => {
		let { activeIndex } = swiper;
		Array.from(document.querySelectorAll(".hero .pagination button")).map(
			(button) => {
				button.classList.toggle(
					"active-slide",
					activeIndex == button.getAttribute("data-slide-index")
				);
			}
		);
	});
});
